export default __webpack_public_path__ + "static/media/delete.9e3d2de9.svg";